import ElementResizeDetector from "element-resize-detector";
import JsPinyin from "js-pinyin";
import SimpleWebWorker from "simple-web-worker";

/**
 * 监听document宽高变化
 * 必须在mounted中使用
 * */
let listenDocumentWH = (doc, callback) => {
  let erd = ElementResizeDetector();
  erd.listenTo(doc, (element) => {
    callback(element.offsetWidth, element.offsetHeight);
  });
};

/**
 * 拼音全拼首字母大写
 * 例：朱亚滨->ZhuYaBin
 * */
let pyFullChars = (words) => {
  if (words === undefined || words === null || words === "") return "";
  return JsPinyin.getFullChars(words);
};

/**
 * 拼音仅保留首字母并大写
 * 例：朱亚滨->ZYB
 * */
let pyCamelChars = (words) => {
  if (words === undefined || words === null || words === "") return "";
  return JsPinyin.getCamelChars(words);
};

/**
 * 开启子线程执行方法
 * func为方法名称
 * args为{}传参
 * */
let childWorker = (that, func, args) => {
  if (func === undefined || func === null || func === "") return;
  const workerUid = "worker_" + that.$system.uuid();
  let simpleWebWorker = SimpleWebWorker.create([
    { message: workerUid, func() {} },
  ]);
  simpleWebWorker.postMessage(workerUid, []).then(() => {
    func(args);
    simpleWebWorker = null;
  });
};

/**
 * 加载public中的脚本文件内容并得到数据
 * obj：入参唯一对象
 * scriptFilePath：不带/前缀的脚本文件路径
 * success：回调函数
 * */
let scriptPublicFile = (that, obj, scriptFilePath, success) => {
  if (
    scriptFilePath === undefined ||
    scriptFilePath === null ||
    scriptFilePath === ""
  )
    return;
  if (success === undefined || success === null || success === "") return;
  that.$system.get(
    that.$store.state.baseUrl + scriptFilePath,
    {},
    false,
    false,
    (data) => success(scriptStr(obj, data))
  );
};

/**
 * 加载脚本字符串内容并得到数据
 * obj：入参唯一对象
 * scriptStr：脚本字符串
 * */
let scriptStr = (obj, data) => {
  function func(obj) {
    return new Function("obj", data)(obj);
  }
  return func(obj);
};

/**
 * 光标聚焦最后
 * focusClass：具体的光标需要结尾的对象
 * */
let focusEnd = (focusClass) => {
  if (focusClass === undefined || focusClass === null) return;
  // 获取焦点
  focusClass.blur();
  focusClass.focus();
  // 如果是input
  if (focusClass.type === "text" || focusClass.type === "textarea") {
    const length = focusClass.value.length;
    focusClass.setSelectionRange(length, length);
    return;
  }
  // 其他
  if (window.getSelection) {
    const range = window.getSelection();
    range.selectAllChildren(focusClass);
    range.collapseToEnd();
    return;
  }
  // 兼容ie10及以下
  if (document.selection) {
    const range = document.selection.createRange();
    range.moveToElementText(focusClass);
    range.collapse(false);
    range.select();
  }
};

/**
 * 字符串转16进制
 * */
let strToHex16 = (str, split) => {
  if (str === undefined || str === null) return null;
  str = String(str);
  const hex16List = [];
  for (let i = 0, length = str.length; i < length; i++) {
    hex16List[i] = str.charCodeAt(i).toString(16);
  }
  return hex16List.join(split);
};

/**
 * 16进制转字符串
 * */
let hex16ToStr = (hex16, split) => {
  if (hex16 === undefined || hex16 === null) return null;
  hex16 = String(hex16);
  const hex16List = hex16.split(split);
  const strList = [];
  for (let i = 0, length = hex16List.length; i < length; i++) {
    strList[i] = String.fromCodePoint(parseInt(hex16List[i], 16));
  }
  return strList.join("");
};

/**
 * 验证值是否为空
 * */
let verifyIsBlank = (value) => {
  if (
    value === undefined ||
    value === null ||
    value.length === 0 ||
    typeof value === "undefined"
  ) {
    return true;
  }
  return false;
};
/**
 * 验证值是否不为空
 * */
let verifyIsNotBlank = (value) => {
  return !verifyIsBlank(value);
};
/**
 * 一维数组变二维数组
 * */
let multidimensionalArrayDeal = (arr, arrLen) => {
  let newArr = [];
  let tempArr = [];
  for (let i = 1; i <= arr.length; i++) {
    tempArr.push(arr[i - 1]);
    if (i % arrLen === 0) {
      newArr.push(tempArr);
      tempArr = [];
    } else if (i === arr.length) {
      newArr.push(tempArr);
    }
  }
  return newArr;
};

/**
 * 二维数组转换一维数组
 * */
let arrayDeal = (arr) => {
  let newArr = [];
  for (let i = 0; i < arr.length; i++) {
    for (let j = 0; j < arr[i].length; j++) {
      newArr.push(arr[i][j]);
    }
  }
  return newArr;
};

/**
 * 字符串数字去除小数点末尾0
 * */
let getNumberByStr = (str) => {
  var numReg = /^[0-9]*$/;
  var numRe = new RegExp(numReg);
  if (verifyIsNotBlank(str) && !numRe.test(str)) {
    return Number(str);
  } else {
    return str;
  }
};

/**
 * 获取当前时间
 * */
let getCurrentTime = () => {
  var date = new Date(); //当前时间
  var year = date.getFullYear(); //返回指定日期的年份
  var month =
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1); //月
  var day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate(); //日
  var hour = date.getHours() > 9 ? date.getHours() : "0" + date.getHours(); //时
  var minute =
    date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes(); //分
  var second =
    date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds(); //秒
  //当前时间
  var curTime =
    year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
  return curTime;
};
/**
 * 根据文件后缀获取文件图标
 * @param file
 * @returns {string}
 */
let dealfilePrefix = (file) => {
  let prefix = file.substring(file.lastIndexOf("."));
  let fileIconShow = "";
  if (prefix === ".pdf" || prefix === ".PDF") {
    fileIconShow = "colorful chis-icon-colorful-pdf";
  } else if (
    prefix === ".doc" ||
    prefix === ".docx" ||
    prefix === ".DOC" ||
    prefix === ".DOCX"
  ) {
    fileIconShow = "colorful chis-icon-colorful-word";
  } else if (
    prefix === ".png" ||
    prefix === ".jpeg" ||
    prefix === ".jpg" ||
    prefix === ".JPG" ||
    prefix === ".JPEG" ||
    prefix === ".PNG"
  ) {
    fileIconShow = "colorful chis-icon-colorful-jpg";
  } else if (prefix === ".mp4") {
    fileIconShow = "colorful chis-icon-colorful-mp4";
  } else if (
    prefix === ".xls" ||
    prefix === ".xlsx" ||
    prefix === ".XLS" ||
    prefix === ".XLSX"
  ) {
    fileIconShow = "colorful chis-icon-colorful-excel";
  } else if (
    prefix === ".ppt" ||
    prefix === ".pptx" ||
    prefix === ".PPT" ||
    prefix === ".PPTX"
  ) {
    fileIconShow = "colorful chis-icon-colorful-ppt";
  }
  return fileIconShow;
};

/**
 * 获取字符串宽度
 * @param text
 * @param fontSize
 * @returns {number}
 */
let getTextWidth = (text, fontSize) => {
  const _span = document.createElement("span");
  _span.innerText = text;
  _span.style.fontSize = fontSize + "px";
  _span.style.position = "absolute";
  document.body.appendChild(_span);
  let width = _span.offsetWidth;
  document.body.removeChild(_span);
  return width;
};

/**
 * @description 格式化金额(自定义)
 * @param number：要格式化的数字
 * @param decimals：保留几位小数 默认0位
 * @param decPoint：小数点符号 默认.
 * @param thousandsSep：千分位符号 默认为,
 */
let formatMoneyCustom = (
  number,
  decimals = 0,
  decPoint = ".",
  thousandsSep = ","
) => {
  number = (number + "").replace(/[^0-9+-Ee.]/g, "");
  let n = !isFinite(+number) ? 0 : +number;
  let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  let sep = typeof thousandsSep === "undefined" ? "," : thousandsSep;
  let dec = typeof decPoint === "undefined" ? "." : decPoint;
  let s = "";
  let toFixedFix = function(n, prec) {
    let k = Math.pow(10, prec);
    return "" + Math.ceil(n * k) / k;
  };
  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  let re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");
  }
  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
};

/**
 * @description 格式化金额
 * @param number：要格式化的数字
 */
let formatMoney = (number) => {
  if (verifyIsNotBlank(number)) {
    number = number + "";
    let money = "";
    if (number.indexOf(".") > 0) {
      let arr = number.split(".") || [];
      money = formatMoneyCustom(number, arr[1].length);
    } else {
      money = formatMoneyCustom(number, 0);
    }
    return money;
  }
  return number;
};

/**
 * 解密--内部使用
 */
export const decode = (array) =>
  array
    .map((itme, i) => itme - i)
    .map((item) => item.toString(16))
    .join("");

/**
 * v-inputMaxlengthLimit 限制el-select允许allow-create时输入的最大长度
 */

export const inserted = (el, binding, vnode) => {
  let inputcontrol = el.querySelector("input.el-input__inner");
  inputcontrol.setAttribute("maxlength", binding.value);
};

export default {
  listenDocumentWH,
  pyFullChars,
  pyCamelChars,
  childWorker,
  scriptPublicFile,
  scriptStr,
  focusEnd,
  strToHex16,
  hex16ToStr,
  verifyIsBlank,
  verifyIsNotBlank,
  multidimensionalArrayDeal,
  arrayDeal,
  getNumberByStr,
  getCurrentTime,
  dealfilePrefix,
  getTextWidth,
  formatMoneyCustom,
  formatMoney,
  inserted,
};
